import { formatDate } from '@/helper'

export default {
  getData (state, _getters, _rootState, rootGetters) {
    return state.data.map((item) => {
      return {
        ...item,
        productListName: item.productList.map(id => rootGetters['product/getDataObject'][id]?.title).filter(Boolean).join(' '),
        isReturnedText: item.isReturned ? 'Да' : 'Нет',
        createdAtFormatted: formatDate(item.createdAt)
      }
    })
  },
  isDataLoaded (state) {
    return state.data.length > 0
  }
}